import React, { useEffect } from 'react';
import './Modal.css';

const Modal = ({ title, isOpen, onClose, children, footer, contentClassName = '', contentStyle = {}, closeOnEsc = true }) => {
  useEffect(() => {
    if (!isOpen || !closeOnEsc) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose?.();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeOnEsc, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-content ${contentClassName}`}
        style={contentStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-button" onClick={onClose} aria-label="Cerrar modal">×</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
        {footer}
      </div>
    </div>
  );
};

export default Modal;
